import { DeliveryMethod } from '../Delivery/DeliveryMethods/DeliveryMethod.csharp';
import { CheckoutViewModel } from '../ViewModel/CheckoutViewModel.csharp';

export class DeliveryMethodValidator {
    private readonly _deliveryMethodsValidators: {
        [type: string]: (checkout: CheckoutViewModel, errors: string[]) => boolean;
    } = {};

    public registerDeliveryMethodValidator = (type: DeliveryMethod, validator: (checkout: CheckoutViewModel, errors: string[]) => boolean): void => {
        this._deliveryMethodsValidators[type.toString()] = validator;
    };

    public unregisterDeliveryMethodValidator = (type: DeliveryMethod) => {
        delete this._deliveryMethodsValidators[type.toString()];
    };

    public validate = (checkout: CheckoutViewModel, errors: string[]): boolean => {
        const methodType = checkout.delivery.selectedDeliveryMethod?.methodType.toString();
        if (methodType) {
            const validator = this._deliveryMethodsValidators[methodType];
            if (validator) {
                return validator(checkout, errors);
            }
        }

        return true;
    };
}

export const deliveryMethodValidator = new DeliveryMethodValidator();
